import React from 'react';

const getQueryInt = (query, queryName) =>
  query?.[queryName] && parseInt(query?.[queryName], 10);

export default {
  path: '/groupedorders/create',
  async action({ query }) {
    const { default: AdminGroupedOrderCreate } =
      await import('./AdminGroupedOrderCreate');
    return (
      <AdminGroupedOrderCreate
        key={'groupedordercreate'}
        sizePerPage={getQueryInt(query, 'sizePerPage')}
        totalCount={getQueryInt(query, 'totalCount')}
      />
    );
  },
};
